<script lang="ts" setup>
import type { ProductAttributeValueSlotDto } from '@repo/api/web/models'

import AttributeBool from './AttributeBool.vue'
import AttributeDecimal from './AttributeDecimal.vue'
import AttributeDict from './AttributeDict.vue'
import AttributeInteger from './AttributeInteger.vue'
import AttributeString from './AttributeString.vue'

const props = defineProps<{
  attribute: ProductAttributeValueSlotDto
}>()

const attributeType = computed(
  () => props.attribute.metadata.defaultConfig?.type,
)
</script>

<template>
  <AttributeString
    v-if="attributeType === 'String'"
    :attribute="props.attribute"
  />
  <AttributeBool
    v-else-if="attributeType === 'Bool'"
    :attribute="props.attribute"
  />
  <AttributeInteger
    v-else-if="attributeType === 'Integer'"
    :attribute="props.attribute"
  />
  <AttributeDecimal
    v-else-if="attributeType === 'Decimal'"
    :attribute="props.attribute"
  />
  <AttributeDict
    v-else-if="attributeType === 'Dict'"
    :attribute="props.attribute"
  />
  <AttributeString v-else :attribute="props.attribute" />
</template>
